import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';

function Home() {
    const [userHist, setUserHist] = useState(false);

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const userPromise = await fetch(
                    process.env.REACT_APP_DATABASE_URL + '/index',
                    {
                        method: 'GET',
                        mode: 'cors',
                        credentials: 'include',
                    }
                );
                const userResponse = await userPromise.json();
                if (userResponse.returning_user) {
                    setUserHist(true);
                } else {
                    setUserHist(false);
                }
            } catch (err) {
                setUserHist(false);
            }
        };

        fetchUser();
    }, []);

    return (
        <div className="h-[100dvh] flex flex-col bg-gradient-to-b from-[#F5F3FF] to-[#F0FDFA] overflow-hidden">
            {/* Top section - Title & Greeting */}
            <div className="pt-16 px-6 text-center">
                {/* Decorative paw prints */}
                <div className="flex justify-center gap-3 mb-4 opacity-30">
                    <i className="fa-solid fa-paw text-[#7C3AED] text-lg rotate-[-20deg]"></i>
                    <i className="fa-solid fa-paw text-[#0F766E] text-sm rotate-[15deg]"></i>
                    <i className="fa-solid fa-paw text-[#7C3AED] text-lg rotate-[-10deg]"></i>
                </div>

                <h1 className="font-title text-5xl sm:text-6xl text-[#0F172A] leading-tight tracking-wide">
                    Kid or Dog
                    <span className="inline-block animate-bounce text-[#7C3AED] ml-1">
                        ?
                    </span>
                </h1>

                <p className="mt-4 text-[#334155] text-base font-medium tracking-wide">
                    Can you tell the difference?
                </p>

                <p className="mt-3 text-[#334155]/60 text-sm">
                    {userHist ? 'Welcome back!' : 'Welcome!'}
                </p>
            </div>

            {/* Middle section - Play Button */}
            <div className="flex-1 flex flex-col items-center justify-center px-6">
                <Link to="/game" className="no-underline">
                    <button
                        className="
                            group relative
                            w-52 h-52 rounded-full
                            bg-[#0F172A]
                            shadow-[0_8px_30px_rgba(15,23,42,0.35)]
                            text-white font-title text-4xl
                            transition-all duration-300 ease-out
                            hover:scale-110 hover:shadow-[0_12px_40px_rgba(15,23,42,0.45)]
                            active:scale-95
                            border-4 border-white/20
                        "
                    >
                        <span className="relative z-10 flex flex-col items-center gap-1">
                            <i className="fa-solid fa-play text-3xl mb-1 group-hover:translate-x-0.5 transition-transform"></i>
                            Play
                        </span>
                        {/* Pulse ring */}
                        <span className="absolute inset-0 rounded-full border-4 border-slate-400/50 animate-ping opacity-20"></span>
                    </button>
                </Link>

                <div className="mt-6 flex gap-4 text-2xl opacity-40">
                    <i className="fa-solid fa-child text-[#7C3AED]"></i>
                    <span className="text-[#334155] text-sm self-center">vs</span>
                    <i className="fa-solid fa-dog text-[#0F766E]"></i>
                </div>
            </div>

            {/* Footer */}
            <footer className="pb-4 pt-2 text-center text-xs text-[#334155]/50">
                <p className="mb-0.5">Made with love in Paris</p>
                <a
                    href="mailto:contact@kidordog.com"
                    className="text-[#334155]/60 hover:text-[#0F172A] transition-colors no-underline"
                >
                    Contact us!
                </a>
            </footer>
        </div>
    );
}

export default Home;
